import React from 'react';
import { purple } from 'globals/colors';

interface FsNoEventsFeedIconProps {
  color?: string;
}

const FsNoEventsFeedIcon: React.FC<FsNoEventsFeedIconProps> = ({
  color = purple.V2,
}) => {
  return (
    <svg
      width="80"
      height="86"
      viewBox="0 0 80 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="1"
        y1="85"
        x2="79"
        y2="85"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M67 14.0094V72C67 73.6569 65.6569 75 64 75H15C13.3431 75 12 73.6569 12 72V4C12 2.34314 13.3431 1 15 1H55.1917C56.0539 1 56.8743 1.3709 57.4439 2.01812L66.2521 12.0275C66.7341 12.5752 67 13.2798 67 14.0094Z"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
};

export default FsNoEventsFeedIcon;
